import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

export default function AgentCard({ agent }) {
  return (
    <motion.div
      whileHover={{ y: -6 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
    >
      <Box
        sx={{
          backgroundColor: "var(--color-white)",
          borderRadius: 3,
          border: "1px solid rgba(207,172,106,0.35)",
          boxShadow: "0 18px 45px rgba(0,0,0,0.08)",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
          transition: "all 0.35s ease",

          "&:hover": {
            boxShadow: "0 30px 70px rgba(0,0,0,0.14)",
            borderColor: "var(--color-gold)",
          },
        }}
      >
        {/* PROFILE IMAGE */}
        <Box
          sx={{
            pt: 3.5,
            pb: 2.5,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: 112,
              height: 112,
              borderRadius: "50%",
              padding: "3px",
              background:
                "linear-gradient(180deg, var(--color-gold), rgba(207,172,106,0.4))",
            }}
          >
            <Box
              component="img"
              src={agent.image}
              alt={agent.name}
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
                backgroundColor: "#eee",
              }}
            />
          </Box>
        </Box>

        {/* CONTENT */}
        <Box sx={{ px: 2.8, pb: 3.2 }}>
          <Typography
            sx={{
              color: "var(--color-text-primary)",
              fontWeight: 600,
              fontSize: 15,
              mb: 0.3,
            }}
          >
            {agent.name}
          </Typography>

          <Typography
            sx={{
              color: "var(--color-gold)",
              fontSize: 12,
              letterSpacing: "0.12em",
              mb: 1.4,
              textTransform: "uppercase",
            }}
          >
            {agent.role}
          </Typography>

          <Typography
            sx={{
              color: "var(--color-text-muted)",
              fontSize: 13,
              lineHeight: 1.65,
              mb: 1.6,
            }}
          >
            {agent.description}
          </Typography>

          <Typography
            sx={{
              fontSize: 11,
              color: "var(--color-text-muted)",
            }}
          >
            Languages:{" "}
            <Box component="span" sx={{ color: "var(--color-text-primary)" }}>
              {agent.languages.join(", ")}
            </Box>
          </Typography>
        </Box>
      </Box>
    </motion.div>
  );
}
